export default class GStatic {

  public static Vars = {
    MortgagesStatusColors : ['0', 'blue', 'orange', 'red', 'green', 'red', 'red']

  };



  /**
   * convert date format from ( 'yyyymmdd'(default) | 'ddmmyyyy') format to d/m/yyyy
   * @param shortDate
   * @param format
   */
  public static convertDateToFront(shortDate: string, format: 'yyyymmdd' | 'ddmmyyyy' = 'yyyymmdd'): string {

    if (format === 'yyyymmdd') {
      return shortDate.substr(6, 2) + '/' + shortDate.substr(4, 2) + '/' + shortDate.substr(0, 4);
    } else {
      return shortDate.substr(0, 2) + '/' + shortDate.substr(2, 2) + '/' + shortDate.substr(4, 4);
    }
  }

  public static convertDateToBack(day: number, month: number, years: number): string {
    return years.toString() + month.toString() + day.toString();
  }


  public static log(...args: any) {
    // if (environment.production === false) {
    // tslint:disable-next-line:no-console
    console.log.apply(console, args);
    // }
  }

  /**
   *  ex: "thisIsExample" => "This is example"
   * @param key
   */
  public static camel2title(key: string) {
    const result = key.replace(/([A-Z][A-Za-z])/g, ' $1');
    return result.charAt(0).toUpperCase() + result.slice(1);
  }

  public static toQueryString(obj: any): string {
    const str: any[] = [];
    for (let p in obj) {
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
      }
    }
    return str.join('&');
  }
}
